import { useEffect, useState } from "react";
import { PrintJson } from "../theme/Component/PrintJson";

interface Props {
    base64: string;
}

export const VisorPDFBase64 = ({ base64 }: Props) => {
    const [urlFile, setUrlFile] = useState<string | null>(null);

    useEffect(() => {
        if (base64) {
            try {
                const base64Url = `data:application/pdf;base64,${base64}`;
                setUrlFile(base64Url);
            } catch (error) {
                console.error("Error generando URL para el PDF:", error);
                setUrlFile(null);
            }
        }
    }, [base64]);

    return (
        <div className="row">
            <div className="col-md-12">
                <div className="iframe-container">
                    {urlFile ? (
                        <iframe
                            name="pdfviewer"
                            src={urlFile}
                            onError={(e) => console.error("Error al cargar el PDF:", e)}
                        ></iframe>
                    ) : (
                        <p>Cargando PDF...</p>
                    )}
                </div>
            </div>
        </div>
    );
};
